interface IProblemLike {
  message?: unknown;
  Message?: unknown;
  detail?: unknown;
  title?: unknown;
  error?: unknown;
}

const firstString = (...candidates: unknown[]): string | undefined => {
  for (const c of candidates) {
    if (typeof c === 'string' && c.trim().length > 0) {
      return c.trim();
    }
  }
  return undefined;
};

const ARGUMENT_NAME_SUFFIX = /\s*\(Parameter\s+'[^']*'\)\s*$/;

const isUnshowableStatus = (status: unknown): boolean =>
  typeof status === 'number' && (status < 400 || status > 499);

const TRANSPORT_NOISE = /^(Network Error|timeout of \d+ms exceeded|Request aborted|canceled)$/i;

export const extractApiErrorMessage = (err: unknown, fallback: string): string => {
  const response = (err as { response?: { status?: number; data?: unknown } })?.response;

  if (isUnshowableStatus(response?.status)) {
    return fallback;
  }

  const data = response?.data;

  if (typeof data === 'string') {
    const trimmed = data.trim().replace(ARGUMENT_NAME_SUFFIX, '');
    if (trimmed.length > 0 && !trimmed.startsWith('<')) {
      return trimmed;
    }
  }

  if (data && typeof data === 'object') {
    const body = data as IProblemLike;
    const fromBody = firstString(body.message, body.Message, body.detail, body.title, body.error);
    if (fromBody) {
      return fromBody.replace(ARGUMENT_NAME_SUFFIX, '');
    }
  }

  if (typeof err === 'string' && err.trim().length > 0) {
    return err.trim();
  }

  const axiosMessage = (err as { message?: unknown })?.message;
  if (
    typeof axiosMessage === 'string'
    && !/^Request failed with status code/i.test(axiosMessage)
    && !TRANSPORT_NOISE.test(axiosMessage.trim())
  ) {
    const trimmed = axiosMessage.trim();
    if (trimmed.length > 0 && !/Cannot read propert/i.test(trimmed)) {
      return trimmed;
    }
  }

  return fallback;
};
